import type { ReportRecordValue } from 'client/js/main/types/analytics';
import { format, parse } from 'date-fns';

export const dayFormatter = (value: ReportRecordValue) => {
  if (typeof value !== 'string') {
    return value;
  }

  try {
    const date = parse(value, 'yyyy-MM-dd', new Date());
    return format(date, 'yyyy/MM/dd');
    // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
  } catch (e) {
    return '';
  }
};
